import styled from 'styled-components';

import ContentEditable from 'react-contenteditable';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 24px;
`;

export const Label = styled.div`
  color: #838a91;
  font-size: 13px;
`;

export const Info = styled.div`
  color: #1a1b1c;
  font-size: 16px;
`;

export const StyledContentEditable = styled(ContentEditable)`
  padding-left: 8px;
  margin-left: -8px;

  color: #1a1b1c;
  :hover {
    background: #f7f7f7;
  }

  :focus {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
    border: none;
    border-radius: 8px;
    background: white;
    height: 32px;
    display: flex;
    align-items: center;
    flex: 1;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: -8px;
    -webkit-appearance: none;

    ::placeholder {
      color: #787878;
    }
  }
`;
